import React from "react"
import Project from "../Projects/Project"
import { useStaticQuery, graphql } from "gatsby"
import Title from "../Title"
import styles from "../../css/items.module.css"
import AniLink from "gatsby-plugin-transition-link/AniLink"


//gets all tours from graphql
const getProjects = graphql`
  query {
    featuredTours: allContentfulTour(filter: { featured: { eq: true } }) {
      edges {
        node {
          name
          slug
          project
          contentful_id
          images {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`

const FeaturedProjects = () => {
  const response = useStaticQuery(getProjects)
  
  //all of my projects are sitting inside this varaible below ->

  const projects = response.featuredTours.edges

    //projects.map grabs all projects in the array..and getting a callback function, 
  //from each item its destructuring the node 
  //node is accessing every node property on that object.

  return (
    <section className={styles.tours}>
      <Title title="Technical" subtitle="Craftsman" />
      <div className={styles.center}>
        {projects.map(({ node }) => {
          return <Project key={node.contentful_id} tour={node} />
        })}
      </div>

      
    </section>
  )
}


// <AniLink fade to="/projects" className="btn-primary">
//         all projects
//       </AniLink>
export default FeaturedProjects
